(function() {

    'use strict';

    angular.module('app').
    controller('MarketPlaceViewController', MarketPlaceViewController);

    MarketPlaceViewController.$inject = ['$scope', '$routeParams', 'MarketPlaceService', 'Location'];

    function MarketPlaceViewController($scope, $routeParams, MarketPlaceService, Location) {

        var vm = this;
        
        vm.marketplaceID = $routeParams.id;
        vm.locationID = null;

        init();

        function init() {
            MarketPlaceService.get(vm.marketplaceID, function(response){
                vm.data = response;
                vm.locationID = response.company.location;

                Location.get(vm.locationID, function(location){
                    vm.data.company.locationName = location.name;
                });
            });
        }

    }
})();


// WEBPACK FOOTER //
// ./js/controllers/marketplaces/MarketPlaceViewController.js